import React from 'react';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import OpenPreviewTagDetail from '../../../../../containers/app/common/OpenPreviewTagDetail';
import Tag from '../../../../../components/tag/Tag';
import Anchor from '../../../../../components/link/Anchor';
import Button from '../../../../../components/Button';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { TAG_STATUS_TEXT } from '../../../../../constants/service/app/tagConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  선택된 상품 후기 아이템 리스트와 상품 후기 리스트의 공통 컬럼
 */
export const columns = (data) => {
  const sortable = !!Object.keys(data).length;
  const { filterOption, onFilter, getRelatedTagList } = data;

  return [
    {
      accessor: 'url',
      Header: '이미지',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} width={'60px'} height={'60px'} />,
    },
    {
      accessor: 'id',
      Header: '태그 ID',
      filterable: !!filterOption,
      Cell: (row) => (
        <Anchor
          text={row.value}
          isUnderLine
          color="primary"
          onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, row.value))}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.tagId} onFilter={(tagId) => onFilter({ tagId })} />,
    },
    {
      accessor: 'name',
      Header: '태그명',
      filterable: !!filterOption,
      Cell: (row) => <OpenPreviewTagDetail text={row.value} tagId={row.original.id} />,
      Filter: () => <TableFilterInput option={filterOption.tagName} onFilter={(tagName) => onFilter({ tagName })} />,
    },
    {
      accessor: 'status',
      Header: '태그 상태',
      Cell: (row) => TAG_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'tagGroupList',
      Header: '태그 그룹',
      Cell: (row) =>
        row.value && row.value.length
          ? row.value.map((tagGroupName, index) => <Tag key={index} text={tagGroupName} isAddHash={false} />)
          : '-',
    },
    {
      id: 'relatedTagList',
      Header: '연관된 태그',
      accessor: 'relatedTagList',
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="태그 보기"
          onClick={() => getRelatedTagList({ tagId: row.original.id })}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '생성일',
      sortable,
      minWidth: 120,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
